<template>
	<div>
		<div class="any_top">
			<div class="title">昨日数据</div>
			<div class="con">
				<!-- <div class="con_li">
					<div class="top">
						<img src="../../assets/img/any_tj.png">
						<div>推荐量</div>
					</div>
					<div class="num"></div>
				</div> -->
				<div class="con_li">
					<div class="top">
						<img src="../../assets/img/any_yd.png">
						<div>阅读量</div>
					</div>
					<div class="num">{{zuoRiData.readNum}}</div>
				</div>
				<div class="con_li">
					<div class="top">
						<img src="../../assets/img/any_xx.png">
						<div>评论量</div>
					</div>
					<div class="num">{{zuoRiData.commentNum}}</div>
				</div>
				<div class="con_li">
					<div class="top">
						<img src="../../assets/img/any_dz.png">
						<div>点赞量</div>
					</div>
					<div class="num">{{zuoRiData.zanNum}}</div>
				</div>
				<div class="con_li">
					<div class="top">
						<img src="../../assets/img/any_sc.png">
						<div>收藏量</div>
					</div>
					<div class="num">{{zuoRiData.shoucangNum}}</div>
				</div>
				<!-- <div class="con_li">
					<div class="top">
						<img src="../../assets/img/any_zf.png">
						<div>分享量</div>
					</div>
					<div class="num">66</div>
				</div> -->
			</div>
		</div>
		<div class="any_top">
			<div class="title">详细数据</div>
			<div class="echarts_class" ref="chart">

			</div>
			<div style="width: 100%;padding:50px 20px;">
				<el-table :data="tableData" style="width: 100%" border>
					<el-table-column prop="createTime" label="日期">
					</el-table-column>
					<el-table-column prop="readNum" label="阅读量">
					</el-table-column>
					<el-table-column prop="commentNum" label="评论量">
					</el-table-column>
					<el-table-column prop="zanNum" label="点赞量">
					</el-table-column>
					<el-table-column prop="shoucangNum" label="收藏量">
					</el-table-column>
				</el-table>
				<el-pagination
				  background
				  layout="prev, pager, next"
				  :total="totalCount" style="padding: 40px 0;" prev-text="上一页" next-text="下一页">
				</el-pagination>
			</div>
		</div>
	</div>
</template>
<script>
	import $ from "jquery";
	import axios from "axios";
	import {
		spawn
	} from "child_process";
	var echarts = require('echarts');
	export default {
		data() {
			return {
				zuoRiData:{
					commentNum:0,
					shoucangNum:0,
					readNum:0,
					zanNum:0,
				},
				tableData: [],
				pageNo:1,
				totalCount:0,
			};
		},
		mounted() {
			this.getallData();
			this.getzuoriData();
			this.get_aData();
		},
		methods: {
			initCharts(xdata,data1,data2,data3,data4) {
				var myChart = echarts.init(this.$refs.chart);
				// 绘制图表
				myChart.setOption({
					xAxis: {
						type: 'category',
						boundaryGap: false,
						data: xdata,
						axisTick: {
							alignWithLabel: true,
						},
					},
					yAxis: {
						type: 'value',
						axisTick: {
							show: false,
						},
						max: 10000,
					},
					series: [{
						data: data1,
						type: 'line',
						smooth: true,
						itemStyle: {
							normal: {
								color: "#2E8043",
								lineStyle: {
									width: 1, //折线宽度
									color: "#2E8043" //折线颜色
								},
								areaStyle: {
									type: 'default',
									color: "rgba(46,128,67,0.2)",
								}
							}
						},
						emphasis:{
							label:{
								show:true,
								formatter: '评论数:{c}',
							},
						},
					},{
						data: data2,
						type: 'line',
						smooth: true,
						itemStyle: {
							normal: {
								color: "#2E8043",
								lineStyle: {
									width: 1, //折线宽度
									color: "#2E8043" //折线颜色
								},
								areaStyle: {
									type: 'default',
									color: "rgba(46,128,67,0.2)",
								}
							}
						},
						emphasis:{
							label:{
								show:true,
								formatter: '收藏数:{c}',
							},
						},
					},{
						data: data3,
						type: 'line',
						smooth: true,
						itemStyle: {
							normal: {
								color: "#2E8043",
								lineStyle: {
									width: 1, //折线宽度
									color: "#2E8043" //折线颜色
								},
								areaStyle: {
									type: 'default',
									color: "rgba(46,128,67,0.2)",
								}
							}
						},
						emphasis:{
							label:{
								show:true,
								formatter: '阅读数:{c}',
							},
						},
					},{
						data: data4,
						type: 'line',
						smooth: true,
						itemStyle: {
							normal: {
								color: "#2E8043",
								lineStyle: {
									width: 1, //折线宽度
									color: "#2E8043" //折线颜色
								},
								areaStyle: {
									type: 'default',
									color: "rgba(46,128,67,0.2)",
								}
							}
						},
						emphasis:{
							label:{
								show:true,
								formatter: '点赞数:{c}',
							},
						},
					}]
				})
			},
			//获取昨日的统计数据
			getzuoriData() {
			 var day1 = new Date();
			 day1.setTime(day1.getTime()-24*60*60*1000);
			 var s1 = day1.getFullYear()+"-" + (day1.getMonth()+1) + "-" + day1.getDate();
			  this.$http
			    .get("/api/topic/010--getStatisticsList", {
			      params: {
					token: this.$store.state.userInfo.token,
					startTime:s1,  
			        endTime:s1,
			      }
			    })
			    .then(res => {
			      if (res.status == 200 && res.data.code == 0) {
					  if(res.data.rows.length>0){
						  this.zuoRiData=res.data.rows[0];
					  }
			      }
			    })
			    .catch(err => {
			      console.log(err);
			    });
			},
			//获取所有的统计数据
			getallData() {
			  this.$http
			    .get("/api/topic/010--getStatisticsList", {
			      params: {
					token: this.$store.state.userInfo.token,
					pageNo:this.pageNo,
					limit:10,
			      }
			    })
			    .then(res => {
			      if (res.status == 200 && res.data.code == 0) {
					this.tableData=res.data.rows;
					this.totalCount=res.data.totalCount;
			      }
			    })
			    .catch(err => {
			      console.log(err);
			    });
			},
			//获取7天的统计数据并且做数据分析
			get_aData() {
			  this.$http
			    .get("/api/topic/010--getStatisticsList", {
			      params: {
					token: this.$store.state.userInfo.token,
					pageNo:1,
					limit:7,
			      }
			    })
			    .then(res => {
			      if (res.status == 200 && res.data.code == 0) {
					// this.chartstableData=res.data.rows;
					if(res.data.rows.length>0){
						//图表数据处理
						this.ArrCatach(res.data.rows)
					}
			      }
			    })
			    .catch(err => {
			      console.log(err);
			    });
			},
			//图表数据处理
			ArrCatach(data){
				var obj={
					commentNum:[],
					shoucangNum:[],
					readNum:[],
					zanNum:[],
					createTime:[],
				}
				for(var i=0;i<data.length;i++){
					obj.commentNum.push(data[i].commentNum);
					obj.shoucangNum.push(data[i].shoucangNum);
					obj.readNum.push(data[i].readNum);
					obj.zanNum.push(data[i].zanNum);
					obj.createTime.push(data[i].createTime.substring(0,10));
				}
				console.log(obj);
				this.initCharts(obj.createTime,obj.commentNum,obj.shoucangNum,obj.readNum,obj.zanNum)
			},
		}
	};
</script>
<style scoped>
	.any_top {
		width: 100%;
		margin: 23px 0 0 20px;
		background: rgba(255, 255, 255, 1);
		box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.16);
	}

	.any_top .title {
		height: 50px;
		line-height: 50px;
		color: #222;
		font-size: 20px;
		text-align: left;
		padding-left: 20px;
		font-weight: 600;
	}

	.any_top .con {
		width: 100%;
		display: flex;
		flex-wrap: wrap;
	}

	.any_top .con_li {
		width: 25%;
		height: 165px;
		text-align: center;
		color: #222;
		font-size: 25px;
	}

	.any_top .con_li .top {
		font-size: 16px;
		color: #999999;
		display: flex;
		margin: auto;
		justify-content: center;
		margin-top: 40px;
		align-items: center;
	}

	.any_top .con_li .top img {
		width: 25px;
		height: 25px;
	}

	.any_top .con_li .num {
		margin-top: 30px;
		font-weight: bold;
	}

	.echarts_class {
		width: 100%;
		height: 415px;
	}
</style>
